import { Component, OnInit, ElementRef, ViewChild  } from '@angular/core';
import { ColDef, GridApi, ColumnApi } from 'ag-grid-community';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import { CatalogosPLMService } from '../../services/catalogosPLM.service';
import { plmModulo } from '../../diccionarios/plm-diccionario';
import { plmService } from '../../services/plm.services';
import { QmMatriz } from '../../models/qm-matriz.model';
import { UtilsService } from 'src/app/shared/utils/utils.service';

@Component({
  selector: 'app-qm-matriz-upload-csv',
  templateUrl: './qm-matriz-upload-csv.component.html',
  styleUrls: ['./qm-matriz-upload-csv.component.css']
})
export class QmMatrizUploadCsvComponent implements OnInit {
  public DAT_TITULOS    = plmModulo.titulos.global;
  public GLOBAL_TITULOS = plmModulo.titulos.global;
  public DAT_AG_GRID    = plmModulo.agGrid;

  uploadedFiles: File[] = [];
  data: QmMatriz[] = [];

  displayPreview = false;
  displayValidacion = false;
  displayForm = true;
  
  loading = false;
  usarioActual: any;
  Titulo_Grid = "Previsualización";

  public columnDefs: ColDef[] = [];
  public gridApi: GridApi;
  public gridColumnApi: any;
  public textoBuscar: string;

  @ViewChild('fileInput') fileInput: ElementRef;
  formulario: FormGroup;

  @ViewChild('dropzone') dropzoneRef!: ElementRef;

  constructor(
    public fb             : FormBuilder,
    private matrizQmService: plmService,
    private utilServices: UtilsService,
    private catalogosPLMService: CatalogosPLMService,
  ) { }

  ngOnInit(): void {
    this.formulario = this.fb.group({ multipart : ['', [Validators.required]]});
    this.usarioActual = JSON.parse(localStorage.getItem('datosUsuarioLogin')).login2;
    this.columnDefs = this.catalogosPLMService.plantillaCabecera()[0].map(item => { return { field: item };});

    this.cargarGridcomponent();
  }

  /** FUNCIONES DEL GRID*/
  cargarGridcomponent() {
   /*const field = this.catalogosPLMService.plantillaCabecera();
    this.columnDefs = field[0].map(item => {
      return { field: item };
    });*/

    this.columnDefs.push(
      { headerName: 'ESTADO', sortable: true, filter: true, width: 150,  initialPinned:"left",
        cellStyle: this.changeRowColor.bind(this), 
        valueGetter: function (params: any) { 
          return (params.data.errorEnCarga === true) ? 'INCORRECTO'  : (params.data.errorEnCarga === false) ? 'CORRECTO' : params.data.errorEnCarga;
        }
      },
      //{ field: 'errores' },
      /*{
        headerName: 'errores',
        field: 'errores',
        filter: true,
        valueGetter: function (params) {
          return (params.data.errores.leght > 1) ? forkJoin ;
        }
      },*/
    );

  }

  onQuickFilterChanged() {
    this.gridApi?.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  changeRowColor(params) {
    let data = params.data;
    if (data.errorEnCarga === false) {
      return {
        'background-color': 'lightgreen',
        'color': 'black',
        'font-weight': 'bold',
        'font-size': '14px'
      };
    }else {
      return {
        'background-color': '#FFC0CB',
        'color': 'black',
        'font-weight': 'bold',
        'font-size': '14px'
      };
    }
    
  }

  gridSetEstado(valor){
    console.log("info del estado", valor);
    
    switch (valor) {
      case undefined:
        return "Por procesar";
      case true:
        return "INCORRECTO";
      case false:
        return "CORRECTO";
      default:
        return "Por procesar";
    }

  }

  onUpload(event: any, drag = false) {
    console.log("file cargado ", event);
    const file: File = drag ? event : event.target.files[0];

    if (!file) return;   

    console.log("file cargado ", file.name);    
    const isCsv = /\.csv$/i.test(file.name);
    //const isExcel = /\.xlsx$/i.test(file.name);

    if (!isCsv) {
      this.utilServices.mensajeErrorVisto('El tipo de archivo no es válido. Use CSV.', true, 5000);
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: ProgressEvent<FileReader>) => {
      const content = e.target?.result as string;
      this.data = this.parseCsv(content);
      this.displayPreview = this.data.length > 0;

      if (!this.displayPreview) {
        this.utilServices.mensajeErrorVisto('No se encontraron registros válidos en el archivo.', true, 4000);
        this.formulario.get('multipart').setValue('');
      } else {
        this.utilServices.alertifyToastOK(`Se cargaron ${this.data.length} registro(s)`);
        this.formulario.get('multipart').setValue(file);
      }
    };

    reader.readAsText(file, 'UTF-8');
    this.uploadedFiles = [file];
  }

  parseCsv(content: string): QmMatriz[] {
    const lines = content.split(/\r?\n/).filter(line => line.trim());
    if (lines.length <= 1) {
      return [];
    }

    const delimiter = lines[0].includes(';') ? ';' : ',';
    return lines.slice(1).map(line => {
      const row = line.split(delimiter).map(col => col.trim().replace(/^"|"$/g, ''));
      return this.mapRowToQmMatriz(row);
    }).filter(row => row.tipo && row.grupo);

  }

  mapRowToQmMatriz(row: any[]): QmMatriz {
    return {
      tipo: row[0],
      grupo: row[1],
      claseInspeccion: row[2],
      descripcionTipoMaterial: row[3],
      descripcionGrupo: row[4],
      descripcionMacrocategoria: row[5],
      gestionQm: row[6],
      especificacionRdl: row[7],
      instruccionProcesoClaseInsp03: row[8],
      operacionesQmClaseInsp03: row[9],
      aprovActivo: row[10],
      claveQm: row[11],
      tipoCoa: row[12],
      puntoInspeccion: row[13],
      tipoPuntoInspeccion: row[14],
      pm0001Cuantitativa: row[15],
      pm0002Cualitativa: row[16],
      pm0003Cuantitativa: row[17],
      pm0004Cualitativa: row[18],
      pm0005Cuantitativa: row[19],
      pm0006Cualitativa: row[20],
      claseUtilizacion: row[21],
      c1001A001: row[22],
      c1001A002: row[23],
      c1001A003: row[24],
      c1001A004: row[25],
      c1001A005: row[26],
      c1001A006: row[27],
      c1001A009: row[28],
      c1002A001: row[29],
      c1002A006: row[30],
      c1002A007: row[31],
      c1002A008: row[32],
      c1002A009: row[33],
      c2001A001: row[34],
      c2001A010: row[35],
      c3001A001: row[36],
      c3001A012: row[37],
      qm1001: row[38],
      qm1002: row[39],
      qm2001: row[40],
      qm3001: row[41],
      usuarioTransaccion: this.usarioActual,
      errorEnCarga: "previsualizacion",
      errores: null
    };
  }

  preCargaData() {
    if (!this.data.length) {
      this.utilServices.mensajeErrorVisto('No hay datos para guardar.', true, 3000);
      return;
    }

    this.displayForm = false;
    this.loading = true;
    this.Titulo_Grid = "Procesando matriz....";
    const payload = this.setFormData(this.formulario.value);

    this.matrizQmService.preUploadCSV(payload).subscribe((res) => {
      this.data = res.items;
      this.Titulo_Grid = "Datos validados";
      this.utilServices.mensajeOKToast('Datos procesados correctamente');
      
      this.displayPreview = true;
      this.displayValidacion = true;
      this.loading = false;
      this.validarRowData();
      //this.reset();
    }, () => {
      this.Titulo_Grid = "Previsualización";
      this.loading = false;
      this.utilServices.mensajeErroToast('No se pudieron procesar los datos');
    });

  }

  guardar() {
    this.utilServices.confirmarSincronoPromesa(
      {
        title   : 'Esta seguro que desea guardar el siguiente listado?',
        text    : 'RDL MATRIZ QM',
        action  : 'Guardar',
        funcion : this.matrizQmService.saveUploadCSV(this.data)
      }
    ).then((res: any) => {
      this.utilServices.mensajeOKVisto(res, true);
      this.regresar();
    }).catch((err) => {
      console.log('Error ' + err);
      this.utilServices.mensajeErrorVisto(err.error.message, true, 3000);
    });

    this.loading = false;
  }

  regresar() {
      this.displayValidacion = false;
      this.displayForm = true;
      this.reset();
  }

  reset() {
    this.Titulo_Grid = "Previsualización";
    this.displayPreview = false;
    this.data = [];
    this.uploadedFiles = [];
    this.formulario.reset();
  }
  
  errorData :boolean = true;
  validarRowData(){
    this.errorData = false;
    this.data.forEach(e => {
      if (e.errorEnCarga) this.errorData =true;
    });
    
  }

  downloadCsvFormato() {
    if(this.displayValidacion) return this.downloadCsvErrores();
    let namePlantilla: string = "plantilla-matrizQM.csv";
    let cabecera: any[] = this.catalogosPLMService.plantillaCabecera();
    const dataMockup: any[] = this.catalogosPLMService.plantillaMockup();
    this.utilServices.exportCSV(cabecera, dataMockup, namePlantilla);
  }

  //metodos de la carga
  setFormData(data: any): FormData {
    const formData = new FormData();
    formData.append('file', new Blob([data.multipart], { type: 'text/csv' }), 'file');
    formData.append('creado', this.usarioActual);
    return formData;
  }

  downloadCsvErrores() {
    let nameFile: string = "REGISTRO_ERRORES.csv";
    let cabecera: any[] = this.catalogosPLMService.plantillaCabecera();
    let clonData = this.data.map((x) => Object.assign({}, x));

    this.utilServices.exportCSV(cabecera, clonData, nameFile);
    this.utilServices.mensajeOKToast('El archivo csv se exportó correctame.');
  }

  //Eventos del drag and drog
  similaInteraccionCarga(){
    const fileInput = document.getElementById('csvInput');
    fileInput.click();
  }

  dragOver(event: DragEvent) {
    event.preventDefault();
    this.dropzoneRef.nativeElement.classList.add('dragover');
  }

  dragLeave() {
    this.dropzoneRef.nativeElement.classList.remove('dragover');
  }

  drop(event: DragEvent) {
    event.preventDefault();
    this.dropzoneRef.nativeElement.classList.remove('dragover');

    const file = event.dataTransfer?.files[0];
    if (file) {
      this.onUpload(file, true);
    }
  }

}
